import React from 'react';
import $ from 'jquery';
var striptags = require('striptags');

class ConversationQuestionOptions extends React.Component{

    constructor(props) {
        super(props);
        let self = this;
        this.state = {
            selectedAnswer:'select',
            selectedAnswerKey:'',
            selectedAnswerText:'',
            selectedAdditionalAnswer:'',
            toggleAns:false,
            toggleIcon:false,
            selectedLi:'',
        }
        this.setResult = this.props.setResult;
        this.setAdditionalResult = this.props.setAdditionalResult;



    }
    componentDidMount() {
        $(window).on('click touch',e=>{
            if(this.state.toggleAns) {
                this.setState({toggleAns: !this.state.toggleAns});
                this.setState({toggleIcon: !this.state.toggleIcon});
            }
        });
    }


    /*handleChangeOption(e){
        let index = e.nativeEvent.target.selectedIndex;
        let text = e.nativeEvent.target[index].text;
       this.setState({selectedAnswer: e.target.value});
       this.setState({selectedAnswerKey: index});
        this.props.setResult(text,index,e.target.name)
        this.props.setAdditionalResult(this.state.selectedAdditionalAnswer)
    };*/
    getAnswers(e){
        e.stopPropagation();
        //$('ul').css('display','none');
        this.setState({toggleIcon:!this.state.toggleIcon});
        this.setState({toggleAns:!this.state.toggleAns});

    }
    selectAnswer(e){
        e.target.setAttribute('checked',true);
       // e.target.setAttribute('class','form-control selectedAnswer dragDrop selected');
        this.setState({selectedAnswerKey:e.target.value});
        this.setState({selectedAnswerText:e.target.innerHTML});

        this.props.setResult(e.target.innerHTML,e.target.value,e.target.name)
        this.props.setAdditionalResult(this.state.selectedAdditionalAnswer)
    }
    render(){
        //console.log(this.state.toggleIcon)
      /*  console.log(this.props.name)*/
            const options = this.props.qOptions
           let answers;
            answers = options.map((option, index) => {
                let id=option[0];
                let strippedOption = striptags(option[1]).toString();
                //return <option key={id} value={id} >{strippedOption}</option>
                return <li
                    className="col-6"
                    key={id}
                    value={id}
                    onClick={this.selectAnswer.bind(this)}>
                    {strippedOption}
                </li>
            });


        return(
            <div className="selectBox">
                <div className="selctDown" onClick={this.getAnswers.bind(this)}>
                    <div>
                        {this.state.selectedAnswerKey?
                            <input
                                className="form-control selectedAnswer dragDrop selected"
                                type='text'
                                placeholder=''
                                key= {this.state.selectedAnswerKey? this.state.selectedAnswerKey : null}
                                value={this.state.selectedAnswerText? this.state.selectedAnswerText : ''}
                                id={this.state.selectedAnswerKey? this.state.selectedAnswerKey : null}
                                readOnly={true}
                            />
                            :
                            <span className="selectedAnswer">
                                {this.state.toggleIcon? <div className="upIcon">&#65087;</div>: <div className="downIcon">&#65088;</div>}
                                <input
                                    className="form-control dragDrop"
                                    type='hidden'
                                    placeholder=''
                                    key={null}
                                    value=''
                                    id={null}
                                    readOnly={true}
                                />
                                     </span>
                        }
                    </div>
                    {this.state.toggleAns?
                        <ul className="selectul col-12" ref={input => { this.resultSelectAns = input; }}>
                            {answers}
                        </ul> :
                        ''}
                </div>
            </div>
        )

    }
}
export default ConversationQuestionOptions;
